import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import React from "react";
import {useLocalTouristTaxExclusionsQuery} from "./query";


const LocalTouristTaxExclusionsSelect = ({formik, name, ...props}) => {

    const localTouristTaxExclusionsQuery = useLocalTouristTaxExclusionsQuery();
    const options = localTouristTaxExclusionsQuery.data ?? [];
    const value = localTouristTaxExclusionsQuery.isLoading ? '' : formik.values[name];

    return <TextField select
                      name={name}
                      value={value}
                      onChange={formik.handleChange}
                      error={formik.touched[name] && Boolean(formik.errors[name])}
                      helperText={formik.touched[name] && formik.errors[name] }
                      SelectProps={{
                          displayEmpty: true,
                      }}
                      InputLabelProps={{
                          shrink: true,
                      }}
                      {...props}>
        <MenuItem value=''>
            Nessuna Esenzione
        </MenuItem>
        {options.map((option) => (
            <MenuItem key={option.localCode} value={option.localCode}>
                {option.description}
            </MenuItem>
        ))}
    </TextField>
}

export default LocalTouristTaxExclusionsSelect;